import gql from "graphql-tag";

export const GET_ALL_EVENTS = gql`
query event($limit: Int = 1000, $offset: Int = 0, $profile_id: uuid, $search_text: String = "%%", $currentDateTime: timestamp) {
  all_event: events(order_by: {created_at: desc}, limit: $limit, offset: $offset, where: {name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    id
    type
    name
    date_time
    description
    event_payment_type
    total_attendees
    is_ticket_required
    event_paid_ticket_details {
      id
      option_name
      description
      price
      quantity_available
    }
    event_image_galleries {
      id
      image_url
      image_path
    }
    event_payment_type
    total_attendees
    categories
    community_id
    start_date_time
    end_date_time
    is_all_day
    location_text
    location
    cover_photo
    cover_photo_path
  }
  upcoming_event: events(order_by: {created_at: desc}, limit: $limit, offset: $offset, where: {start_date_time: {_gt: $currentDateTime}, name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    id
    type
    name
    date_time
    description
    event_payment_type
    total_attendees
    is_ticket_required
    event_paid_ticket_details {
      id
      option_name
      description
      price
      quantity_available
    }
    event_image_galleries {
      id
      image_url
      image_path
    }
    event_payment_type
    total_attendees
    categories
    community_id
    start_date_time
    end_date_time
    is_all_day
    location_text
    location
    cover_photo
    cover_photo_path
  }
  past_event: events(order_by: {created_at: desc}, limit: $limit, offset: $offset, where: {end_date_time: {_lt: $currentDateTime}, name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    id
    type
    name
    date_time
    description
    event_payment_type
    total_attendees
    is_ticket_required
    event_paid_ticket_details {
      id
      option_name
      description
      price
      quantity_available
    }
    event_image_galleries {
      id
      image_url
      image_path
    }
    event_payment_type
    total_attendees
    categories
    community_id
    start_date_time
    end_date_time
    is_all_day
    location_text
    location
    cover_photo
    cover_photo_path
  }
  all_count: events_aggregate(where: {name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    aggregate {
      count
    }
  }
  upcoming_count: events_aggregate(where: {start_date_time: {_gt: $currentDateTime}, name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    aggregate {
      count
    }
  }
  past_count: events_aggregate(where: {end_date_time: {_lt: $currentDateTime}, name: {_ilike: $search_text}, _or: [{business_profile_id: {_eq: $profile_id}}, {council_profile_id: {_eq: $profile_id}}]}) {
    aggregate {
      count
    }
  }
}

`;